import { render, staticRenderFns } from "./MoneyInput.vue?vue&type=template&id=6a53d87c&scoped=true"
import script from "./MoneyInput.vue?vue&type=script&lang=js"
export * from "./MoneyInput.vue?vue&type=script&lang=js"
import style0 from "./MoneyInput.vue?vue&type=style&index=0&id=6a53d87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a53d87c",
  null
  
)

export default component.exports